export enum CompanySettingErrors {
  NO_COMPANY_ID = "NO_COMPANY_ID",
}
